export const downloadCsvTemplate = () => {
	const headers = [
		'Documento',
		'Nome do beneficiario',
		'Tipo de Movimentacao',
		'Tipo de chave',
		'Chave Pix',
		'Tipo de Conta',
		'ISPB',
		'Agencia',
		'Conta',
	];

	const csvContent = [headers.join(';')].join('\n');

	const blob = new Blob([csvContent], {
		type: 'text/csv;charset=utf-8;',
	});

	const url = window.URL.createObjectURL(blob);

	const link = document.createElement('a');
	link.href = url;
	link.setAttribute('download', 'template_importacao.csv');

	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
};
